import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import CheckoutModal from './CheckoutModal';
import './CartDrawer.css';

function fmtFcfa(n) {
  return Number(n).toLocaleString('fr-FR') + ' FCFA';
}

function unitLabel(unit) {
  if (unit === 'mois')    return '/ mois';
  if (unit === 'analyse') return '/ analyse';
  if (unit === 'unique')  return '(unique)';
  return '';
}

export default function CartDrawer() {
  const {
    showCart, setShowCart, cart, updateCartQty, removeFromCart, clearCart, cartTotal, showToast,
  } = useApp();
  const [showCheckout, setShowCheckout] = useState(false);

  if (!showCart) return null;

  function handleRemove(it) {
    if (window.confirm(`Retirer « ${it.name} » du panier ?`)) {
      removeFromCart(it.id);
      showToast(`${it.name} retiré du panier`, 'warn');
    }
  }

  function handleQtyMinus(it) {
    if (it.qty <= 1) {
      handleRemove(it);
      return;
    }
    updateCartQty(it.id, it.qty - 1);
  }

  function handleClearCart() {
    if (window.confirm('Vider tout le panier ? Cette action est irréversible.')) {
      clearCart();
      showToast('Panier vidé', 'warn');
    }
  }

  return (
    <>
      <div className="cart-overlay" onClick={() => setShowCart(false)} />
      <div className="cart-drawer">
        <div className="cart-head">
          <h3>🛒 Mon panier</h3>
          <button className="cart-close" onClick={() => setShowCart(false)}>✕</button>
        </div>

        <div className="cart-body">
          {cart.length === 0 ? (
            <div className="cart-empty">
              <div className="cart-empty-icon">🛒</div>
              <p>Votre panier est vide.</p>
              <p className="cart-empty-sub">Parcourez notre boutique et ajoutez une application.</p>
              <a href="#boutique" className="cart-empty-btn" onClick={() => setShowCart(false)}>
                Voir la boutique →
              </a>
            </div>
          ) : (
            <>
              {cart.map(it => (
                <div key={it.id} className="cart-item">
                  <div className="cart-item-icon">
                    {it.iconImage ? <img src={it.iconImage} alt="" style={{ width: 22, height: 22, borderRadius: 5, objectFit: 'cover' }} /> : it.icon}
                  </div>
                  <div className="cart-item-info">
                    <div className="cart-item-name">{it.name}</div>
                    <div className="cart-item-price">
                      {fmtFcfa(it.unitPrice)} <span>{unitLabel(it.unit)}</span>
                    </div>
                    <div className="cart-item-qty">
                      <button onClick={() => handleQtyMinus(it)} title={it.qty <= 1 ? 'Retirer du panier' : 'Diminuer'}>−</button>
                      <span>{it.qty}</span>
                      <button onClick={() => updateCartQty(it.id, it.qty + 1)} title="Augmenter">+</button>
                    </div>
                  </div>
                  <div className="cart-item-right">
                    <div className="cart-item-total">{fmtFcfa(it.unitPrice * it.qty)}</div>
                    <button className="cart-item-del" onClick={() => handleRemove(it)} title="Supprimer">🗑</button>
                  </div>
                </div>
              ))}
              <button className="cart-clear-btn" onClick={handleClearCart}>🗑 Vider le panier</button>
            </>
          )}
        </div>

        {cart.length > 0 && (
          <div className="cart-foot">
            <div className="cart-total-row">
              <span>Total</span>
              <span className="cart-total-amt">{fmtFcfa(cartTotal)}</span>
            </div>
            <button className="cart-checkout-btn" onClick={() => setShowCheckout(true)}>
              Passer la commande →
            </button>
          </div>
        )}
      </div>

      {showCheckout && (
        <CheckoutModal onClose={() => setShowCheckout(false)} />
      )}
    </>
  );
}
